// extracted by mini-css-extract-plugin
export default {"item":"styles_item__MndAV","item_title":"styles_item_title__NZKiK","item_light":"styles_item_light__Kftrw","item_light_title":"styles_item_light_title__mQYjP"};